export default {"src":"/_next/static/media/diamond_ring_64.96dfa063.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};